export default __webpack_public_path__ + "static/media/notice_icon.2284c5c0.svg";